import React, { FC, useState } from "react";


type Props = {
  buttonText?: string;
  onSave: () => Promise<void>;
};

const SettingsSubmitButton: FC<Props> = ({ onSave, buttonText = "Save" }) => {
  const [disabled, setDisabled] = useState<boolean>(false);
  const save = async () => {
    setDisabled(true);
    onSave().finally(() => {
      setDisabled(false);
    });
  };

  return (
    <button className="btn btn-primary float-right" onClick={save} disabled={disabled}>
      {buttonText}
    </button>
  );
};

export default SettingsSubmitButton;